const state = {
	loading: false,
};

const mutations = {
	SHOW_GLOBAL_LOADING_SPINNER(state) {
		state.loading = true;
	},
	HIDE_GLOBAL_LOADING_SPINNER(state) {
		state.loading = false;
	},
};

const actions = {
	showGlobalLoadingSpinner({ commit }) {
		commit('SHOW_GLOBAL_LOADING_SPINNER');
	},
	hideGlobalLoadingSpinner({ commit }) {
		commit('HIDE_GLOBAL_LOADING_SPINNER');
	},
};

export default {
	state,
	mutations,
	actions,
};
